import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import helper from './helper';
import { ValidateRequestPayload } from './types';
const ENDPOINT = 'validate/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  get: (payload: ValidateRequestPayload) =>
    instance.get<any, AxiosResponse<ApiResponse<boolean>>>(
      ENDPOINT +
        payload.name +
        '/' +
        helper.toQueryString({ ...payload, name: undefined }),
      config
    ),
  checkOutletSfa: (sfaId: number, currentSfaId: string) => 
    instance.get<any, AxiosResponse<ApiResponse<boolean>>>(ENDPOINT + 'outlet_sfa/' + helper.toQueryString({ sfa_id: sfaId, current_sfa_id: currentSfaId }), config)
});
